import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { setCanonical, syncSocialMeta } from "@/lib/usePageMeta";

/**
 * On every route change: scroll to top, point canonical/og:url at the current
 * route, and keep the og:/twitter: tags in step with whatever title/description
 * the page sets (many pages set document.title directly). Must be inside <BrowserRouter>.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    setCanonical(pathname);
    syncSocialMeta({ resetImage: true });
  }, [pathname]);

  useEffect(() => {
    const obs = new MutationObserver(() => syncSocialMeta());
    obs.observe(document.head, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ["content"] });
    return () => obs.disconnect();
  }, []);

  return null;
}
